/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServerInformation } from '../../models/server-information';

export interface ServerInformationGetServerInformation$Params {

/**
 * Locale information to localize all possible information in response
 */
  locale?: string;
}

export function serverInformationGetServerInformation(http: HttpClient, rootUrl: string, params?: ServerInformationGetServerInformation$Params, context?: HttpContext): Observable<StrictHttpResponse<ServerInformation>> {
  const rb = new RequestBuilder(rootUrl, serverInformationGetServerInformation.PATH, 'get');
  if (params) {
    rb.query('locale', params.locale, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServerInformation>;
    })
  );
}

serverInformationGetServerInformation.PATH = '/server-information';
